import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter, Input,
  OnDestroy,
  OnInit, Output,
  ViewChild
} from '@angular/core';
import {fromEvent, Subscription} from 'rxjs';
import {debounceTime} from 'rxjs/operators';
import {ViewportScroller} from '@angular/common';
import {Group} from '../../../../../../chat-sdk/src/entities/groups/group';

@Component({
  selector: 'app-chat-scrollbar',
  templateUrl: 'item.html',
  styleUrls: ['item.scss'],
  // changeDetection: ChangeDetectionStrategy.OnPush
})
export class ChatScrollbarComponent implements OnInit, OnDestroy {
  @ViewChild('markerTop') markerTop!: ElementRef;
  @ViewChild('markerBottom') markerBottom!: ElementRef;
  @Output() scrolledToTop = new EventEmitter<void>();
  @Output() scrolledToBottom = new EventEmitter<void>();
  @Output() isShowScrollToBottom = new EventEmitter<boolean>();

  @Input() group: Group;

  private _sub!: Subscription;

  constructor(
    private elementRef: ElementRef,
    private scroller: ViewportScroller
  ) {
  }

  get _element(): HTMLElement {
    return this.elementRef.nativeElement as HTMLElement;
  }

  ngOnInit() {

    // console.log('scroll to');
    // if (this.group.dynamicData.firstUnreadMessageId) {
    //   setTimeout(() => {
    //
    //     console.log(this.group.dynamicData.firstUnreadMessageId);
    //     console.log(document.getElementById(this.group.dynamicData.firstUnreadMessageId));
    //     console.log(document.getElementById(this.group.dynamicData.firstUnreadMessageId).offsetTop);
    //
    //     this._element.scrollTo({top: document.getElementById(this.group.dynamicData.firstUnreadMessageId).offsetTop});
    //
    //     // this.scroller.scrollToAnchor(this.group.dynamicData.firstUnreadMessageId);
    //   }, 1000);
    // }

    this._sub = fromEvent(this._element, 'scroll').pipe(
      debounceTime(50)
    ).subscribe(v => {
      this.checkParams();
    });
  }

  checkParams() {
    const markerTopRect = (this.markerTop.nativeElement as HTMLElement).getBoundingClientRect();
    const markerBottomRect = (this.markerBottom.nativeElement as HTMLElement).getBoundingClientRect();
    const elementRect = this._element.getBoundingClientRect();
    if (Math.abs(markerTopRect.top - elementRect.top) < 10) {
      // console.log('scrolledToTop');
      this.scrolledToTop.emit();
    }

    if (Math.abs(markerBottomRect.bottom - elementRect.bottom) < 10) {
      // console.log('scrolledToBottom');
      this.scrolledToBottom.emit();
    }

    if (Math.abs(markerBottomRect.bottom - elementRect.bottom) < 200) {
      // console.log('isShowScrollToBottom false');
      this.isShowScrollToBottom.emit(false);
    } else {
      this.isShowScrollToBottom.emit(true);
      // console.log('isShowScrollToBottom true');
    }
  }

  ngOnDestroy() {
    this._sub?.unsubscribe();
  }

  scrollToBottom(smooth: boolean = true) {
    console.log('scrollToBottom');
    this._element.scrollTo({
      top: 0,
      behavior: smooth ? 'smooth' : 'auto'
    });
  }

  scrollToMessage(messageId: string) {
    const msg = document.getElementById(`${messageId}`);
    if (msg) {
      const contentHeight = this._element.offsetHeight / -2 + 110;
      this._element.scrollTo({
        top: (Math.abs(msg.offsetTop) * -1) + contentHeight,
        behavior: 'auto'
      });
    }
  }

  scrollbarCurrentPositionX() {
    return Math.abs(this._element.scrollTop)|| 0;
  }
}
